import { keyframes } from 'styled-components/macro';

export const show = keyframes`
  0% {opacity: 0;}
  100% {opacity: 1;}
`;

export const loading = keyframes`
  to {
    background-position-x: -20%;
  }
`;

export const flyUp = keyframes`
    0%{
        transform: translateY(0);
    }
    100%{
        transform: translateY(-6%);
    }
`;

export const flyDown = keyframes`
    0%{
        transform: translateY(0);
    }
    100%{
        transform: translateY(6%);
    }
`;
